
// Bit flags for listing.featureLevel. Kept in step with
// api/src/lib/feature-flags.js — change one, change the other.
const levels = {
    "LOGO": 1,
    "SHORT_DESCRIPTION": 2,
    "REMOVE_NEARBY": 4,
    "UPLOAD_GALLERY_PHOTOS": 8,
    "RESERVATION_LINK": 16,
    "WELCOME_MESSAGE": 32,
    "WINE_CLUB_PROMOTION": 64,
    "CUSTOM_FLIGHT_COVER": 128,
    "MODERATE_USER_PHOTOS": 256,
    "ADVANCED_ANALYTICS": 512,
    "ADVANCED_PASSPORT_ANALYTICS": 1024,
    "LISTING_QR_CODE": 2048,
}

// What each tier ADDS to the one before it — mirrors api/src/lib/feature-flags.js.
// Cumulative by construction, so a higher tier can never grant less than a lower
// one. (The old {claimed:1, enhanced:10, premium:100, reserve:111} map was tier
// LABELS used as bitmasks, and upgrading actually removed features.)
const TIER_ADDITIONS = [
    ["claimed", []],
    ["enhanced", ["SHORT_DESCRIPTION", "WELCOME_MESSAGE", "LISTING_QR_CODE"]],
    ["premium", ["LOGO", "WINE_CLUB_PROMOTION", "RESERVATION_LINK", "UPLOAD_GALLERY_PHOTOS",
                 "CUSTOM_FLIGHT_COVER", "MODERATE_USER_PHOTOS",
                 "ADVANCED_ANALYTICS", "ADVANCED_PASSPORT_ANALYTICS"]],
    ["reserve", ["REMOVE_NEARBY"]],
];

export const TIER_LABELS = {
    claimed: "Claimed",
    enhanced: "Enhanced",
    premium: "Premium",
    reserve: "Reserve",
};

/** The cheapest tier that includes this flag, or null if no tier grants it. */
export function tierForFlag(flag) {
    for (const [tier, additions] of TIER_ADDITIONS) {
        if (additions.some((name) => levels[name] === flag)) return tier;
    }
    return null;
}

export default levels;